import gql from "graphql-tag";
const completeRegister = gql`
  query completeRegister($token: String!) {
    completeRegister(token: $token) {
      accessToken
      refreshToken
      username
      firstname
      surname
    }
  }
`;
export default completeRegister;